/* NovaHealthBot global Buy It Now v2 — exact live variant checkout */
(() => {
  if (window.__NHB_BUY_IT_NOW_V2__) return;
  window.__NHB_BUY_IT_NOW_V2__ = true;

  const INSURANCE_VARIANT_ID = 67571481379206;
  const PREF_KEY = 'nhbShippingInsurance';

  const setBusy = (button, busy) => {
    button.disabled = busy;
    button.toggleAttribute('aria-disabled', busy);
    button.classList.toggle('loading', busy);
    button.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
  };

  const showError = (productForm, message = '') => {
    const wrapper = productForm.querySelector('.product-form__error-message-wrapper');
    const target = productForm.querySelector('.product-form__error-message');
    if (!wrapper || !target) return;
    wrapper.toggleAttribute('hidden', !message);
    target.textContent = message;
  };

  const getSelectedVariant = (productForm, variantInput) => {
    const sectionId = productForm.dataset.sectionId || '';
    const pickers = Array.from(document.querySelectorAll('variant-selects, variant-radios'));
    const picker =
      pickers.find((element) => element.dataset.section === sectionId) ||
      productForm.closest('.product__info-container')?.querySelector('variant-selects, variant-radios');
    const dataNode = picker?.querySelector('script[type="application/json"]');

    try {
      const data = JSON.parse(dataNode?.textContent || 'null');
      if (data && !Array.isArray(data) && data.id) return data;
      if (Array.isArray(data)) {
        const selectedOptions = Array.from(
          picker.querySelectorAll('fieldset, select'),
          (group) => group.matches('select')
            ? group.value
            : group.querySelector('input[type="radio"]:checked')?.value,
        ).filter(Boolean);
        return data.find(
          (variant) =>
            variant.id &&
            variant.options?.every((option, index) => option === selectedOptions[index]),
        ) || null;
      }
    } catch (_) {}

    const fallbackId = Number(variantInput?.value);
    return fallbackId ? { id: fallbackId, available: !variantInput.disabled } : null;
  };

  const checkoutUrl = (variantId, quantity, includeInsurance, sellingPlan) => {
    const root = window.Shopify?.routes?.root || '/';
    const lines = [String(variantId) + ':' + String(quantity)];
    if (includeInsurance && variantId !== INSURANCE_VARIANT_ID) {
      lines.push(String(INSURANCE_VARIANT_ID) + ':1');
    }
    let url = root + 'cart/' + lines.join(',') + '?checkout';
    if (sellingPlan) url += '&selling_plan=' + encodeURIComponent(sellingPlan);
    return url;
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-nhb-buy-it-now]');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const productForm = button.closest('product-form');
    const form = productForm?.querySelector('form');
    const variantInput = form?.querySelector('input[name="id"]');
    const selectedVariant = productForm && form
      ? getSelectedVariant(productForm, variantInput)
      : null;
    const variantId = Number(selectedVariant?.id);
    if (!productForm || !form || !variantId || selectedVariant?.available === false) {
      showError(productForm, 'Please select an available option before continuing.');
      return;
    }

    // Some custom card presentations update the native variant JSON before the
    // hidden form input. Synchronize it immediately so checkout always receives
    // the card the customer can actually see as selected.
    if (variantInput && String(variantInput.value) !== String(variantId)) {
      variantInput.value = String(variantId);
      variantInput.disabled = false;
    }

    const formData = new FormData(form);
    const quantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
    const sellingPlan = formData.get('selling_plan') || '';
    const checkbox = productForm.querySelector('[data-nhb-insurance-checkbox]');
    const includeInsurance = Boolean(
      productForm.hasAttribute('data-nhb-shipping-insurance-v1') && (!checkbox || checkbox.checked),
    );

    try {
      sessionStorage.setItem(PREF_KEY, includeInsurance ? '1' : '0');
    } catch (_) {}

    showError(productForm);
    setBusy(button, true);
    window.location.assign(checkoutUrl(variantId, quantity, includeInsurance, sellingPlan));
  }, true);
})();
